import React, { useEffect, useState } from 'react';
import "./style.sass";
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useHistory, useParams } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { postBlockIncode } from 'services/RequestBlockIncode';
import { PantallaError500 } from './pantallaError500';
import { decodeStorage } from 'functions/storageBase64';
import { ModalError } from 'components/Error/ErrorModal';
import { ModalLoadingCredit } from 'components/Loading';


export function PantallaError(props) {

    const {objError} = props;

    const EXTERNO = decodeStorage('EXTERNO');

    const [objErrorState, setObjErrorState] = useState(objError);

    const history = useHistory();

    const params = useParams();

    const [error, setError] = useState(false);

    const errors = {
        "suspencion-temporal": [
            {
                "message_parent": "No puedes continuar con la solicitud, tu cuenta no es apta",
                "type": "text",
                "child": null
            },
            {
                "message_parent": "Intentalo en [30] días",
                "type": "text",
                "child": null
            }
        ],
        "lista-negra": [
            {
                "message_parent": "No puedes iniciar con la solicitud, tu cuenta no es apta para Crédito ClaroShop",
                "type": "text",
                "child": null
            }
        ],
        "no-aprobo-csr": [
            {
                "message_parent": "No puedes continuar con la solicitud, tu cuenta no es apta para un crédito",
                "type": "text",
                "child": null
            }
        ],
        "numero-de-intentos-exedidos": [
            {
                "message_parent": "No puedes continuar, has superado el número de intentos",
                "type": "text",
                "child": null
            },
            {
                "message_parent": "Podrás reintentarlo dentro de [tres meses]",
                "type": "text",
                "child": null
            }
        ],
        "error1": "No puedes continuar con la solicitud, tu cuenta no es apta para un crédito",
        "error-incode": "error de servicio",
        "solicitud-rechazada-tipo1": [
            {
                "message_parent": "Lo sentimos, tu solicitud de crédito ha sido rechazada",
                "type": "text",
                "child": null
            },
            {
                "message_parent": "Te recomenamos:",
                "type": "text",
                "child": [
                    {
                        "message_parent": "Contar con la documentacion clara y veraz.",
                        "type": "text",
                        "child": null
                    },
                    {
                        "message_parent": "Ampliar tu historial crediticio.",
                        "type": "text",
                        "child": null
                    },
                    {
                        "message_parent": "Tener buena calificacion en Búro de crédito.",
                        "type": "text",
                        "child": null
                    },
                    {
                        "message_parent": "Volver a intentarlo en [tres meses].",
                        "type": "text",
                        "child": null
                    }
                ]
            }
        ],
        "solicitud-rechazada-tipo2": [
            {
                "message_parent": "Lo sentimos, tu solicitud de crédito ha sido rechazada",
                "type": "text",
                "child": null
            },
            {
                "message_parent": "Tu cuenta no es apta para un crédito",
                "type": "text",
                "child": null
            }
        ]
    }

    const profileData = decodeStorage('profileData');

    const [postBlockIncodeRes, setPostBlockIncodeRes] = useState(false);

    const [ loading, setLoading ] = useState(false);

    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);

    const handleIrHome = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}`);
    };

    const handleCloseErr = () => {
        window.location.href = `${BASE_PATH}`;
    }

    useEffect(() => {
        if(params?.error){
            setError(errors[params?.error])
            if(params?.error === "numero-de-intentos-exedidos"){
                console.log("se manda error de numero excedido de intentos")
                setLoading(true);
                postBlockIncode(profileData?.idClaro)
                .then(setPostBlockIncodeRes)
            }
        }
    }, [params])


    //respuesta block Incode (se manda cuando excede el numero de intentos)
    useEffect(() => {
        if (postBlockIncodeRes) {
            //console.log("respuesta block Incode",postBlockIncodeRes)
            if(postBlockIncodeRes?.statusCode === 200){
                setLoading(false);
                if(postBlockIncodeRes?.data?.respuesta === 'true'){
                    //para poner "lo sentimos" en el mensaje
                    let obj = postBlockIncodeRes?.data;
                    obj.tieneCredito = "No";
                    setObjErrorState(obj);
                }else{
                    //mandar error modalito
                    setShowModalErr(true);
                    setErrorCode(postBlockIncodeRes?.statusCode);
                    setSectionActive('verificar');
                    setMessageResponse(postBlockIncodeRes?.data?.codMen);
                }
            }else if(postBlockIncodeRes?.statusCode > 200 && postBlockIncodeRes?.statusCode < 500){
                setLoading(false);
                setShowModalErr(true);
                setErrorCode(postBlockIncodeRes?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(postBlockIncodeRes?.data?.codMen);
          }
          else{
                setLoading(false);
                setErrorCode(postBlockIncodeRes?.statusCode);
          }  
        }
      }, [postBlockIncodeRes])

    return (
        <>
        { loading && <ModalLoadingCredit /> }
        {errorCode >= 500
            ? <PantallaError500 />
            : <main className='nuevoCredito'>
                <div className="modalCredito full">
                    <div className="contentModal error">
                    {
                        EXTERNO ? null : <HeaderMobileCredito logo="img/logo-claroshop.png" type="close" />
                    }

                        <div className="contenedorGeneral">
                            <div className="sFmobile">
                                {objErrorState && objErrorState?.tieneCredito === "Si" ?
                                    objErrorState?.tipo === 1 ? <img src="img/group2.png" className="credito-claroScore"></img>
                                    :
                                    objErrorState?.tipo === 2 && <img src="img/group.png" className="credito-claroScore"></img>
                                    
                                    : <img src="img/icon_alerta.png"></img>
                                }

                                {/*<h2 className="tituloFin colorVerde">¡Tu solicitud ha sido enviada con éxito!</h2>*/}

                                {objErrorState ?
                                    <>
                                        {objErrorState?.leyenda1 && 
                                            <p className="copyNormal">
                                                {objErrorState?.tieneCredito === "Si" ? null : <span className='bold'>¡Lo sentimos! </span>}
                                                {objErrorState?.leyenda1}
                                            </p>}

                                        {objErrorState?.leyenda2 && <p className="copyNormal">{objErrorState?.leyenda2}</p>}
                                    </>
                                :null}
                                
                                {error ?
                                    params?.error ==='suspencion-temporal' || params?.error ==='lista-negra' || params?.error ==='no-aprobo-csr' ?
                                        error.map((info, iPrincipal) =>              
                                            <div key={iPrincipal}>
                                                <p className="copyNormal">
                                                    {iPrincipal === 0 &&
                                                        <span className='bold'>¡Lo sentimos! </span> 
                                                    }    
                                                    {info?.message_parent}
                                                </p>
                                            </div>
                                        ) 
                                    :null
                                :null
                                }

                                {error ?
                                    params?.error ==='solicitud-rechazada-tipo1' || params?.error ==='solicitud-rechazada-tipo2' ?
                                        error.map((info, iPrincipal) =>              
                                            <div key={iPrincipal}>
                                                <p className={iPrincipal === 0 ? '' : info?.message_parent.includes('recomenamos') ? 'text-left mt-30' : 'mt-30'}>
                                                    <span className={iPrincipal === 0 ? 'bold' : ''}>{info?.message_parent}</span>
                                                </p>

                                                {info.child != null &&
                                                    <div className='boxUl  marginBottom20'>
                                                        <ul className="ulBeneficios">
                                                            {info.child.map((hijos, i) =>
                                                                <li className="liBeneficios">
                                                                    <div className="boxIcon">
                                                                        <div className="icon"> </div>
                                                                    </div>
                                                                    <div className="copy"> {hijos?.message_parent}</div>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    :null
                                :null
                                }
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div className="boxBtnSolicitar">
                    <button className="btnSolicitar" onClick={handleIrHome}>Enterado</button>
                </div>
            </main>
        }
        {showModalErr &&
            <ModalError
                errorCode={errorCode}
                section={sectionActive}
                message={messageResponse}
                handleClose={handleCloseErr}
            />
        }
    </>
    );
}